import { StrictMode, createRoot } from "@wordpress/element";
import SliderEntidades from "./SliderEntidades";

// Mount the component to the 'root' div
const roots = document.querySelectorAll('.slider-entidades-swiper');

roots.forEach((root) => {
  const displaySearchForm = root.getAttribute('data-display-search-form');
  const perSlide = parseInt(root.getAttribute('data-per-slide')) ?? 4;
  const filterEntidades = root.getAttribute('data-filter');

  createRoot(root).render(
    <StrictMode>
      <SliderEntidades 
        filterEntidades={filterEntidades}
        displaySearchForm={displaySearchForm}
        perSlide={perSlide}
      />
    </StrictMode>
  );
});